<template>
  <div class="w-full lg:w-1/2" style="margin-top: 10rem;">
    <vx-card title="Processing Board Invitees" class="org-card mt-base">
      <!-- CHART -->
      <template slot="no-body">
        <div class="mt-10">
          <vue-apex-charts
            type="radialBar"
            height="240"
            :options="goalOverviewRadialBar.chartOptions"
            :series="goalOverview.series"
          />
        </div>
      </template>

      <!-- DATA -->
      <p class="mt-6">
          Processing Invitee: {{xlsxBoardUserInviteProgress.currentUserEmail}}
      </p>
      <div class="flex justify-between text-center mt-6" slot="no-body-bottom">
        <div
          class="
            w-1/2
            border border-solid
            d-theme-border-grey-light
            border-r-0 border-b-0 border-l-0
          "
        >
          <p class="mt-4">Invitees Processed</p>
          <p class="mb-4 text-3xl font-semibold">{{goalOverview.analyticsData.processedUsers}}</p>
        </div>
        <div
          class="
            w-1/2
            border border-solid
            d-theme-border-grey-light
            border-r-0 border-b-0
          "
        >
          <p class="mt-4">Total Invitees</p>
          <p class="mb-4 text-3xl font-semibold">{{goalOverview.analyticsData.totalUsers}}</p>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";

export default {
  props: {
    xlsxBoardUserInviteProgress: {
      type: Object,
      required: true,
    },
  },
  components: {
    VueApexCharts,
  },
  data() {
    return {
      goalOverviewRadialBar: {
        // series: [83],
        chartOptions: {
          plotOptions: {
            radialBar: {
              size: 110,
              startAngle: -150,
              endAngle: 150,
              hollow: {
                size: "77%",
              },
              track: {
                background: "#bfc5cc",
                strokeWidth: "50%",
              },
              dataLabels: {
                name: {
                  show: false,
                },
                value: {
                  offsetY: 18,
                  color: "#99a2ac",
                  fontSize: "4rem",
                },
              },
            },
          },
          colors: ["#00db89"],
          fill: {
            type: "gradient",
            gradient: {
              shade: "dark",
              type: "horizontal",
              shadeIntensity: 0.5,
              gradientToColors: ["#00b5b5"],
              inverseColors: true,
              opacityFrom: 1,
              opacityTo: 1,
              stops: [0, 100],
            },
          },
          stroke: {
            lineCap: "round",
          },
          chart: {
            sparkline: {
              enabled: true,
            },
            dropShadow: {
              enabled: true,
              blur: 3,
              left: 1,
              top: 1,
              opacity: 0.1,
            },
          },
        },
      },
      goalOverview: {
        analyticsData: {
          processedUsers: 0,
          totalUsers: 1,
        },
        series: [85],
      },
    };
  },
  watch: {
      xlsxBoardUserInviteProgress(val) {
          this.goalOverview.analyticsData.processedUsers = Number(val.processedUsers);
          this.goalOverview.analyticsData.totalUsers = Number(val.totalUsers);
          const percent = Math.round((Number(val.processedUsers*100))/(Number(val.totalUsers)));
          this.goalOverview.series = [percent];
      }
  },
  mounted() {
      this.goalOverview.analyticsData.processedUsers = Number(this.xlsxBoardUserInviteProgress.processedUsers);
      this.goalOverview.analyticsData.totalUsers = Number(this.xlsxBoardUserInviteProgress.totalUsers);
      const percent = Math.round((this.goalOverview.analyticsData.processedUsers*100)/(this.goalOverview.analyticsData.totalUsers));
      this.goalOverview.series = [percent];
  },
};
</script>